<div class="flex flex-col items-center justify-center font-inter text-white bg-transparent animate-slideUp">
    <div class="p-10 md:p-10 max-w-full bg-transparent">
        <div class="flex flex-col items-center justify-center text-center">
            <div class="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10 text-center">
                <!-- Iterate through guides -->
                <div class="transition-transform duration-300 hover:scale-105 cursor-pointer"
                    *ngFor="let guide of guides" (click)="openGuide(guide)">
                    <div
                        class="border border-white bg-gradient-to-b from-[rgba(29,37,85,0.80)] to-[rgba(5,5,12,0.80)] rounded-lg shadow-lg py-6 px-14 text-white transition duration-300 hover:border-yellow-400 hover:text-yellow-400 flex flex-col">
                        <h3 class="text-3xl mt-6">{{ guide.title }}</h3>
                        <p class="text-xs text-gray-400">Click to read more</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal for Guide Details -->
<div *ngIf="selectedGuide" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div
        class="bg-black p-6 rounded-lg shadow-lg w-11/12 md:w-3/4 lg:w-2/3 xl:w-1/2 max-h-[80%] border border-gray-700">
        <h2 class="text-white text-lg font-semibold mb-4">{{ selectedGuide.title }}</h2>
        <div class="text-white text-sm overflow-y-auto max-h-[60vh] pr-4 ">
            <markdown class="prose dark:prose-dark" [data]="selectedGuide.content"></markdown>
        </div>

        <div class="flex justify-end space-x-2 mt-4">
            <button type="button"
                class="bg-transparent border border-[#289DD2] text-[#289DD2] px-4 py-2 rounded opacity-70"
                (click)="closeModal()">
                Close
            </button>
        </div>
    </div>
</div>
